export default __webpack_public_path__ + "static/media/flag-mali.1f6b7f2d.svg";